// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__3IvC9","question":"Question_question__2gRed","description":"Question_description__Em7My"};